import { Icon, Typography } from "@material-ui/core";
import * as React from "react";
import portalIconSW from "src/resources/themedportal-icon-small-white.png";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";

const styles = createStyles({
  root: {
    backgroundColor: "#111111",
    height: "1.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: "rgb(162, 162, 162)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
  },
  icon: {
    height: "1.25rem",
    paddingRight: ".5rem",
  },
});

class SmallFooter extends React.Component<WithStyles<typeof styles>> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { classes } = this.props;
    const copyright = new Date().getFullYear();
    return (
      <div className={classes.root} />
      // <div className={classes.root}>
      //   <img
      //     src={portalIconSW}
      //     className={classes.icon}
      //     alt="The Med Portal"
      //   />
      //   <Typography className={classes.text}>
      //     ©{copyright} The Med Portal
      //   </Typography>
      // </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SmallFooter);



// WEBPACK FOOTER //
// ./src/components/footer/SmallFooter.tsx